// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_qrY","cls2":"PaperBrowserPreviewList-cls2_E3j PaperBrowserPreviewList-cls1_qrY"};